<template>
  <div
    :class="{
      _boxBg_green_secondLevel: styleType == 'typeGreen',
      _boxBg_dark_secondLevel: styleType == 'typeDark',
      _boxBg_blue_secondLevel: styleType == 'typeBlue',
    }"
    class="absolute_center list_transport"
  >
    <div class="selfClose_btn" style="top: 10px" @click="close"></div>
    <div class="boxTitle">汽运统计数据</div>
    <div class="boxSelect">
      <el-form :inline="true" class="boxSelect">
        <el-form-item label="查询月份：">
          <el-date-picker
            v-model="timeArr"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            style="width: 265px"
            :disabledDate="pickerOptions"
            popper-class="listTransportPop"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <a class="self_btn" @click="getData()">查询</a>
          <a class="self_btn" @click="getReset()">重置</a>
          <a class="self_btn" @click="exportExcel()">导出表格</a>
        </el-form-item>
      </el-form>
    </div>
    <div class="boxBody">
      <div class="boxListBody" v-if="tableData">
        <el-table
          :data="tableData"
          :span-method="objectSpanMethod"
          height="760"
          style="width: 100%"
        >
          <el-table-column label="车次/车辆统计" align="center">
            <el-table-column
              prop="type"
              align="center"
              label="进/出"
              width="150"
              fixed
            >
            </el-table-column>
            <el-table-column
              prop="materialType"
              align="center"
              label="物料分类"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="materialName"
              align="center"
              label="物料名称"
              width="180"
            >
            </el-table-column>
            <template v-for="(item, key) in timeArrSet" :key="key">
              <el-table-column :label="item" align="center">
                <el-table-column
                  :prop="item + '[vehicleTimes]'"
                  align="center"
                  label="车次"
                  width="180"
                >
                </el-table-column>
                <el-table-column
                  :prop="item + '[vehicleCount]'"
                  align="center"
                  label="车辆"
                  width="180"
                >
                </el-table-column>
                <el-table-column
                  :prop="item + '[totalWeight]'"
                  align="center"
                  label="累计重量"
                  width="300"
                >
                </el-table-column>
              </el-table-column>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { dateFormat } from "@/utils/tools.js";
export default {
  name: "listOverview",
  title: "详细信息",
  props: ["globalInstance"],
  data() {
    return {
      styleType: "",
      type: "",
      timeArr: [
        dateFormat(
          "YYYY-mm",
          new Date(new Date() - 1 * 30 * 24 * 60 * 60 * 1000)
        ),
        // dateFormat("YYYY-mm", new Date()),
        dateFormat("YYYY-mm", new Date()),
      ],
      tableData: "",
      arr1: [],
      arr2: [],
      customerId: this.$store.state.customerId,
      timeArrSet: [],
    };
  },
  setup(props) {
    const globalInstance = props.globalInstance;
    return { globalInstance };
  },
  computed: {
    ...mapState({ cleanTransportIp: "cleanTransportIp" }),
    curStyleTypeVal() {
      return this.globalInstance.$store.state.styleType;
    },
  },
  created() {
    // this.arr2 = this.setdates(this.tableData, "materialType");
  },
  mounted() {
    this.styleType = this.globalInstance.$store.state.styleType;
    this.getData();
  },
  methods: {
    pickerOptions(time) {
      return time.getTime() >= new Date().getTime();
    },
    getReset() {
      this.timeArr = [
        dateFormat(
          "YYYY-mm",
          new Date(new Date() - 1 * 30 * 24 * 60 * 60 * 1000)
        ),
        // dateFormat("YYYY-mm", new Date()),
        dateFormat("YYYY-mm", new Date()),
      ];
      this.getData();
    },
    close() {
      let that = this._.appContext.app;
      this.$popup.close(that);
    },
    setdates(arr, key) {
      var obj = {},
        k,
        arr1 = [];
      for (var i = 0, len = arr.length; i < len; i++) {
        k = arr[i][key]; //需要合并的字段
        if (obj[k]) obj[k]++;
        else obj[k] = 1;
      }
      //   console.log(obj);
      for (var o in obj) {
        for (let i = 0; i < obj[o]; i++) {
          if (i === 0) {
            arr1.push(obj[o]);
          } else {
            arr1.push(0);
          }
        }
      }
      return arr1;
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      //   console.log(row, column, rowIndex, columnIndex);
      if (columnIndex === 0) {
        let _row = this.arr1[rowIndex];
        let _col = this.arr1[rowIndex] > 0 ? 1 : 0;
        return [_row, _col];
      }
      if (columnIndex === 1) {
        if (row.type == "外售") {
          let _row = this.arr2[rowIndex];
          let _col = this.arr2[rowIndex] > 0 ? 1 : 0;
          return [_row, _col];
        } else {
          let _row = this.arr2[rowIndex];
          let _col = this.arr2[rowIndex] > 0 ? 1 : 0;
          return [_row, _col];
        }
      }
    },
    getMonth() {
      this.timeArrSet = [];
      let monthLength =
        new Date(this.timeArr[1]).getMonth() -
        new Date(this.timeArr[0]).getMonth() +
        1 +
        (new Date(this.timeArr[1]).getFullYear() -
          new Date(this.timeArr[0]).getFullYear()) *
          12;
      console.log(monthLength);
      for (let i = 1; i <= monthLength; i++) {
        let baseMonth = new Date(this.timeArr[0]).getMonth(),
          baseYear = new Date(this.timeArr[0]).getFullYear(),
          year,
          month;
        if (baseMonth + i > 12) {
          year = baseYear + 1;
          month = baseMonth + i - 12;
        } else {
          year = baseYear;
          month = baseMonth + i;
        }
        if (String(month).length == 1) {
          month = "0" + month;
        }
        this.timeArrSet.push(year + "-" + month);
      }
      //   console.log(new Date(this.timeArr[0]).getMonth() + 1);
      //   return [
      //     dateFormat("YYYY-mm", new Date(this.timeArr[0])),
      //     dateFormat("YYYY-mm", new Date(this.timeArr[1])),
      //   ];
    },
    async getData() {
      this.getMonth();
      let url = this.cleanTransportIp + "/transport/materialStatisticInfo";
      let res = await this.globalInstance.$apiUtils.get(url, {
        customerId: this.customerId,
        startTime: this.timeArrSet[0],
        endTime: this.timeArrSet[this.timeArrSet.length - 1],
      });
      if (res) {
        this.tableData = [];
        res.materialInOutTypeMonthInfoList.forEach((itemCF) => {
          if (itemCF.inoutType && itemCF.materialTypeMothInfoList) {
            itemCF.materialTypeMothInfoList.forEach((itemType) => {
              if (itemType.materialMothInfoList) {
                itemType.materialMothInfoList.forEach((itemName) => {
                  let obj = {
                    type: itemCF.inoutType == 1 ? "采购" : "外售",
                    materialType:
                      itemCF.inoutType == 1
                        ? itemType.materialType
                        : " " + itemType.materialType + " ",
                    materialName: "",
                  };
                  obj.materialName = itemName.materialName;
                  if (itemName.materialStatisticInfoList) {
                    itemName.materialStatisticInfoList.forEach((itemMonth) => {
                      itemMonth.totalWeight = itemMonth.totalWeight.toFixed(2);
                      //   obj[itemMonth.month + "totalWeight"] =
                      //     itemMonth.totalWeight;
                      //   obj[itemMonth.month + "vehicleCount"] =
                      //     itemMonth.vehicleCount;
                      //   obj[itemMonth.month + "vehicleTimes"] =
                      //     itemMonth.vehicleTimes;
                      obj[itemMonth.month] = itemMonth;
                    });
                  }
                  this.tableData.push(obj);
                });
              }
            });
          }
          console.log(this.tableData);
        });
        this.arr1 = this.setdates(this.tableData, "type");
        this.arr2 = this.setdates(this.tableData, "materialType");
        this.$forceUpdate();
        console.log(this.arr2);
      }
    },
    exportExcel() {
      this.getMonth();
      this.showTips = true;
      let that = this;

      setTimeout(function () {
        that.showTips = false;
      }, 5000);
      let ip = this.cleanTransportIp;
      let str = `${ip}/transport/materialStatistic/export?startTime=${
        this.timeArrSet[0] || dateFormat("YYYY-mm", new Date())
      }&endTime=${
        this.timeArrSet[this.timeArrSet.length - 1] ||
        dateFormat("YYYY-mm", new Date())
      }&customerId=${this.customerId}`;
      let a = document.createElement("a");
      a.setAttribute("href", str);
      a.setAttribute("id", "startTelMedicine");
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      let elem = document.getElementById("startTelMedicine");
      elem.parentNode.removeChild(elem);
    },
  },
};
</script>
<style lang='scss' scoped>
.list_transport {
  width: 1900px;
  height: 980px;
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .boxTitle {
    text-align: center;
    font-size: 32px;
    font-weight: 700;
    color: #f7b500;
    line-height: 33px;
    text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
    margin: 28px 0;
  }
  .boxSelect {
    display: flex;
    width: 800px;
    justify-content: space-between;
  }
  .boxBody {
    margin: 0 auto;
    width: 1700px;
    height: 780px;
    overflow: hidden;
    .boxListBody {
      ::-webkit-scrollbar {
        width: 12px; /*对垂直流动条有效*/
        height: 12px; /*对水平流动条有效*/
      }
      padding: 10px;
    }
  }
}
._boxBg_green_secondLevel {
  background: url("./img//bg.png") no-repeat center center;
  // border: 1px solid #05FFFA;
  background-size: 100% 100%;
  box-shadow: none;
}
.selfClose_btn {
  position: absolute;
  right: 78px;
}
</style>
<style lang="scss">
.list_transport {
  .el-table {
    background: rgba(4, 39, 35, 1) !important;
  }
  .el-table__header {
    margin-right: 12px;
  }
  .el-table .el-table__body-wrapper .el-table__body tr.el-table__row,
  .el-table--border th,
  .el-table--border td {
    // border: 1px solid #8badff;
  }
  .el-table__header-wrapper {
    background: rgba(4, 39, 35, 1) !important;
  }
  .el-table thead.is-group th {
    background: rgba(4, 39, 35, 1) !important;
    border-right: 1px solid #8badff !important;
    border-bottom: 1px solid #8badff !important;
  }
  .el-table__header {
    background: rgba(4, 39, 35, 1) !important;
    border-left: 1px solid #8badff !important;
    border-top: 1px solid #8badff !important;
  }
  .el-table__body-wrapper {
    background: rgba(4, 39, 35, 1) !important;
  }
  .el-table__body {
    background: rgba(4, 39, 35, 1) !important;
  }
  ._boxBg_green_secondLevel.list_overview
    .el-date-editor--datetimerange.el-input,
  .el-date-editor--datetimerange.el-input__inner {
    background: rgba(0, 0, 0, 0.2) !important;
    box-shadow: 0px 1px 1px 0px #05fffa !important;
    border-radius: 6px !important;
  }
  .basic-item {
    .secondLevel-input {
      width: 260px;
      input {
        background: rgba(0, 0, 0, 0.2) !important;
        box-shadow: 0px 1px 1px 0px #05fffa !important;
        border-radius: 6px !important;
        height: 40px;
        width: 260px;
        border-radius: 6px !important;
        border: 1px solid !important;
      }
      .el-input .el-input__inner {
        color: #f4c48f !important;
      }
    }
  }

  ._boxBg_green_secondLevel.list_overview
    .basic-item
    .el-input
    .el-input__inner {
    color: #f4c48f !important;
    font-size: 21px;
    font-weight: bold;
    width: 260px;
    height: 40px;
  }

  ._boxBg_green_secondLevel.list_overview .el-input .el-input__inner {
    color: rgb(101, 245, 242);
  }

  ._boxBg_green_secondLevel.list_overview
    .el-form-item__content
    .el-date-editor
    input {
    color: rgb(101, 245, 242) !important;
    &::placeholder {
      color: rgb(101, 245, 242, 0.5) !important;
    }
  }

  ._boxBg_green_secondLevel.list_overview .table_box .thClass > .cell {
    color: #05fffa;
  }

  ._boxBg_green_secondLevel.list_overview .el-table__empty-block {
    width: 100% !important;
  }

  ._boxBg_green_secondLevel.list_overview .el-pagination {
    font-size: 18px;
  }

  ._boxBg_green_secondLevel.list_overview
    .page_box
    .el-pagination__editor
    .el-input__inner {
    font-size: 18px;
  }
  ._boxBg_green_secondLevel.list_overview {
  }
  .el-range-separator {
    color: white;
  }
}
.listTransportPop {
  .el-month-table td.disabled .cell {
    background-color: #9b9b9b !important;
  }
}
</style>
